import { Link, useLocation } from 'react-router-dom';

const tools = [
  { name: 'Rankings', href: '/players' },
  { name: 'Trade Calculator', href: '/trade-calculator' },
  { name: 'Draft Assistant', href: '/draft-assistant' },
  { name: 'My Roster', href: '/my-roster' },
];

const company = [
  { name: 'About', href: '/about' },
  { name: 'Contact', href: '/contact' },
];

const legal = [
  { name: 'Privacy policy', href: '/privacy-policy' },
  { name: 'Terms of service', href: '/terms-of-service' },
];

export const Footer = () => {
  const { pathname } = useLocation();
  const year = new Date().getFullYear();

  return (
    <footer className="footer-glow relative overflow-hidden border-t border-white/10 bg-ink">
      <div className="relative z-10 mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-12 lg:px-8">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-md">
            <Link to="/" className="inline-flex items-center gap-3">
              <img
                src="/images/Fantasy Fiesta Logo - Transparent.png"
                alt=""
                className="h-9 w-auto object-contain"
              />
              <span className="font-display text-lg font-semibold text-white">
                Fantasy Fiesta
              </span>
            </Link>
            <p className="mt-3 text-sm leading-relaxed text-zinc-400">
              Rankings, trades, drafts, and your roster in one desk.
            </p>
          </div>

          <nav aria-label="Tools" className="flex flex-wrap gap-2 lg:hidden">
            {tools.map((item) => {
              const current = pathname === item.href;
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  aria-current={current ? 'page' : undefined}
                  className={`rounded-full border px-3.5 py-2 text-sm transition-colors ${
                    current
                      ? 'border-fiesta-yellow/40 bg-fiesta-yellow/15 text-fiesta-yellow'
                      : 'border-white/10 bg-white/5 text-zinc-300 hover:border-white/20 hover:text-white'
                  }`}
                >
                  {item.name}
                </Link>
              );
            })}
          </nav>
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-sm">
            {company.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={`text-zinc-400 hover:text-white ${
                  pathname === item.href ? 'text-white' : ''
                }`}
              >
                {item.name}
              </Link>
            ))}
            <a
              href="https://x.com/Fiesta_Fantasy"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-zinc-400 hover:text-white"
            >
              <svg className="h-3.5 w-3.5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.725-8.835L1.254 2.25H8.08l4.253 5.622L18.244 2.25zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z" />
              </svg>
              <span>Follow on X</span>
            </a>
            <a
              href="mailto:info@fantasy-fiesta.com"
              className="text-zinc-400 hover:text-white"
            >
              info@fantasy-fiesta.com
            </a>
          </div>

          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-zinc-500">
            <p>© {year} Fantasy Fiesta</p>
            {legal.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className="hover:text-zinc-300"
              >
                {item.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};
